import { AmplitudeEvent, AmplitudeEventSource } from "@analytics/Amplitude/AmplitudeEvents";
import { DateFilterType } from "./AmplitudeTaskManagementEvents";

export class FilterTasksByTagEvent extends AmplitudeEvent {
    constructor(props: { source: AmplitudeEventSource; selectedTagCount: number }) {
        super("filter_tasks_by_tag");
        this.props = props;
    }
}

export class FilterTasksByProjectEvent extends AmplitudeEvent {
    constructor(props: { source: AmplitudeEventSource; selectedProjectsCount: number }) {
        super("filter_tasks_by_project");
        this.props = props;
    }
}

export class FilterTasksByStatusEvent extends AmplitudeEvent {
    constructor() {
        super("filter_tasks_by_status");
    }
}

export class FilterTasksByDateEvent extends AmplitudeEvent {
    constructor(props: { dateFilterType: DateFilterType }) {
        super("filter_tasks_by_date");
        this.props = props;
    }
}
